/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download PNG`)
};

const es_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar PNG`)
};

const de_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG herunterladen`)
};

const nl_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG downloaden`)
};

const fr_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger le PNG`)
};

const it_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica PNG`)
};

const pt_br2_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar PNG`)
};

const pt_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar PNG`)
};

const ja_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNGをダウンロード`)
};

const zh_qr_download = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 PNG`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_download = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_download(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_download", locale)
	if (locale === "en") return en_qr_download(inputs)
	if (locale === "es") return es_qr_download(inputs)
	if (locale === "de") return de_qr_download(inputs)
	if (locale === "nl") return nl_qr_download(inputs)
	if (locale === "fr") return fr_qr_download(inputs)
	if (locale === "it") return it_qr_download(inputs)
	if (locale === "pt-BR") return pt_br2_qr_download(inputs)
	if (locale === "pt") return pt_qr_download(inputs)
	if (locale === "ja") return ja_qr_download(inputs)
	return zh_qr_download(inputs)
};